module.exports = __webpack_public_path__ + "img/cyberhaltestelle_monitor.1df506be.png";